import { BaseModel } from './base.model';
import { Picture } from './picture.model';

export class Destination extends BaseModel {
  country: string;
  continent: string;
  description: string;
  coverPictureId: string;
  coverPicture: Picture;
}
